import { IMAGE_WIDTH } from './constants';

const getScrollObject = ({ forward, scrollBehaviour, scrollableRef = {} }) => {
  const { current: { offsetWidth, scrollLeft, scrollWidth } = {} } = scrollableRef;

  if (scrollLeft + offsetWidth >= scrollWidth && forward) {
    return {
      left: -scrollWidth,
      behavior: scrollBehaviour
    };
  }

  return {
    left: forward ? offsetWidth : -offsetWidth,
    behavior: scrollBehaviour
  };
};

const getMaxWidthForImages = width => {
  if (!width) return '100%';
  const maxImages = Math.floor(width / IMAGE_WIDTH);
  return `${maxImages * IMAGE_WIDTH}px`;
};

export { getScrollObject, getMaxWidthForImages };
